import { Checkbox, FormControlLabel, Typography } from "@material-ui/core"
import React from "react"
import { chartStyles } from "../../styles"

export type CheckboxProps = {
  onChange: (_: React.ChangeEvent<HTMLInputElement>) => void
  checked: boolean
  disabled?: boolean
  label: string
}
export default function GCFCheckbox(props: CheckboxProps) {
  const { label, onChange, checked, disabled } = props

  return (
    <FormControlLabel
      style={{ zIndex: 2, pointerEvents: "none" }}
      control={
        <Checkbox
          color="primary"
          checked={checked}
          disabled={disabled}
          onChange={onChange}
          style={{ pointerEvents: "all" }}
          className={disabled ? chartStyles.disabledCheck : chartStyles.button}
        />
      }
      label={
        <Typography
          className={
            disabled ? chartStyles.disabledLabel : chartStyles.labelCheckbox
          }
        >
          {label}
        </Typography>
      }
    />
  )
}
